// extracted by mini-css-extract-plugin
export var header = "_bn-0";